import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { useLazyQuery } from '@apollo/client';
import { GET_VEHICLE_BY_SOURCE_ID } from '../../GraphQL/Queries/vehicles';

import Flags from '../Common/Flags';
import { Trans } from 'react-i18next';

export const EUVehicleCard = ({ settings, vehicle }) => {
    const [vehicleImage, setVehicleImage] = useState(settings.images.vehicle_placeholder);

    const [getVehicleQuery, { loading: loadingVehicle }] = useLazyQuery(GET_VEHICLE_BY_SOURCE_ID, {
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (vehicle?.Photos) {
            const imageUrl = `https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/${vehicle.Photos}`;
            setVehicleImage(imageUrl);
        } else {
            getVehicleQuery({ variables: { sourceVehicleId: +vehicle.V_ID } })
                .then((vehicleResponse) => {
                    const gqlVehicle = vehicleResponse?.data.getVehicleBySourceVehicleId;

                    if (gqlVehicle?.photoUrl) {
                        setVehicleImage(gqlVehicle?.photoUrl);
                    }
                })
        }
    }, [vehicle])

    return (
        <Link to={"/vehicle/" + vehicle.V_ID} onClick={() => window.scrollTo(0, 0)} className="eu-vehicle-card--new">
            <div className="eu-vehicle-card--new-img" style={{ backgroundImage: `url(${vehicleImage})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}}>
                <Flags vehicle={vehicle} vehicle_details={settings.vehicle_details} />
            </div>
            <div className="eu-vehicle-card--new-desc">
                <h2 className = "eu-vehicle-card--new-title">{vehicle.Year} {vehicle.Make} {vehicle.Model} {vehicle.Trim}</h2><br/>
                <p className = "eu-vehicle-card--new-nextavail"><span className = "black-lightest"><Trans>Next Availability</Trans>: </span>{moment(vehicle.First_Available_Date).format("MMM DD, YYYY")}</p>
            </div>
        </Link>
    )
};
